import React from "react";
import Loading from "../../../../ui-components/loading/loading";

interface ProgressTypeTileContentProps {
    isLoading: boolean;
    title: string;
    value: number;
    totalValue: number;
}

export const ProgressTypeTileContent: React.FC<ProgressTypeTileContentProps> = (props) => {
    let progress = 0;

    if (props.totalValue && props.totalValue > 0 && props.value) {
        progress = (props.isLoading) ? 0 : Math.floor((props.value / props.totalValue) * 100)
    }
    return (
        <div className="content__progress">
            <div className="content__progress__summary-porgress-bar__container">
                <span className="content__progress__summary-porgress-bar__info">
                    {(props.isLoading)? <Loading isLoading={true} />:
                        <span className="content__progress__summary-porgress-bar__progress-percentage">{progress}%</span>
                    }
                    <span className="content__progress__summary-porgress-bar__progress">
                        {(props.title) ? ` ${props.title}` : ""}
                    </span>
                </span>
                <div className={"content__progress__summary-porgress-bar__bar" + (progress === 100 ? " --completed" : "")}>
                    <div style={{ width: progress + "%" }}></div>
                </div>
            </div>
        </div>
    )
};